import type { NewProposedAppointmentInboxItem } from '@seen/core/models/inbox'
import { IconCalendarQuestion } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'
import { InboxRow } from '#src/pages/inbox/row/InboxRow.tsx'
import { InboxRowContent } from '#src/pages/inbox/row/InboxRowContent.tsx'
import { InboxRowSubtext } from '#src/pages/inbox/row/InboxRowSubtext.tsx'
import { InboxRowText } from '#src/pages/inbox/row/InboxRowText.tsx'

export interface NewProposedAppointmentInboxItemRowProps {
  item: NewProposedAppointmentInboxItem
  notificationItem: NotificationItem
  onSelect?: () => void
  isSelected?: boolean
  sidebarOpen?: boolean
}

export function NewProposedAppointmentInboxItemRow({
  item,
  notificationItem,
  onSelect,
  isSelected,
  sidebarOpen,
}: NewProposedAppointmentInboxItemRowProps): ReactNode {
  return (
    <InboxRow
      to={item.actionUrl}
      notificationItem={notificationItem}
      onSelect={onSelect}
      isSelected={isSelected}
      sidebarOpen={sidebarOpen}
    >
      <IconCalendarQuestion />
      <InboxRowContent>
        <InboxRowText notificationItem={notificationItem}>
          New proposed appointment
        </InboxRowText>
        <InboxRowSubtext>New proposed appointment</InboxRowSubtext>
      </InboxRowContent>
    </InboxRow>
  )
}
